export default (data) => {
  let parsedData = null
  try {
    parsedData = JSON.parse(data)
    // eslint-disable-next-line no-empty
  } catch (e) {}
  return parsedData
}
